/*
    These should have the same value as the corresponnding variables in /css/variables.styl
*/

// Internal variables
const deepLavender = '#7356a4';
const squash = '#f5a623';
const azure = '#00a8e6';
const resursGreen = '#67bc44';
const resursOrange = '#e15500';
const resursBlue = '#0033a1';
const resursDarkBlue = '#211551';
const resursEggplant = '#72246c';
const resursPeach = '#fcc89b';

/* Form colors from My pages UI style guide 20190125 */
const resursFormValid = '#6CC24A';
const resursFormInvalid = '#DA291C';

const style = {
    colors: {
        colorLink: '#4572ED',
        colorRawbBlack: '#000',
        colorRawbWhite: '#ffffff',
        colorRawbDarkgrey: '#646464',
        colorRawbLightgrey: '#dcdcdc',
        colorRawbRed: '#dc2828',
        colorRawbOrange: '#f5781e',
        colorRawbGreen: '#91cd28',
        colorRawbPurple: '#af1ed2',
        colorRawbDarkblue: '#145aaa',
        colorRawbBrightblue: '#28b4dc',
        colorLightLightgrey: '#f3f3f3',
        colorRawbGrey: '#888888',
        colorDarkplate: '#2f353d',
        deepLavender: deepLavender,
        squash: squash,
        azure: azure,
        lightTeal: '#afdeec',
        corporatePrimary: resursEggplant,
        privatePrimary: resursOrange,
        gunMetal: '#4d5057',
        darkDarkGrey: '#121518',
        humanyColor: resursBlue,
        resursGreen: resursGreen,
        resursBlue: azure,
        colorResursLightGrey: '#dddddd',
        colorResursOrange: resursOrange,
        colorResursBlue: resursBlue,
        colorResursDarkBlue: resursDarkBlue,
        colorResursEggplant: resursEggplant,
        colorResursLightLightGrey: '#f2f2f2',
        colorResursPeach: resursPeach,
        colorResursMidGrey: '#9f9f9f',
        colorMypagesBlue: '#99D6EA',
        formValid: resursFormValid,
        formInvalid: resursFormInvalid,
    },
    fonts: {
        mainFonts: 'SST,"Helvetica Neue",Helvetica,Arial,sans-serif',
    },
    breakpoints: {
        smallMobileMaxWidth: 320,
        mobileMaxWidth: 420,
        tabletMaxWidth: 768,
        desktopSmallMaxWidth: 980,
        desktopMaxWidth: 1152,
    },
    padding: {
        desktop: {
            bottom: 24,
        },
        mobile: {
            bottom: 32,
        },
    },
    mobileMenu: {
        width: '80', // unit will be used as vw
        paddingTop: 65,
    },
    desktopMenu: {
        paddingTop: 112,
        submenuHeight: 48,
    },
};

module.exports = style;
